import { Alert, Button } from 'antd'
import Status from '../../../elements/Status'
import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'

const CheckboxTable = checkboxHOC(CustomTable)

const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 200,
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/packages/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  { Header: 'PKG Name', accessor: 'name', hideable: true, hideDefault: false },
  { Header: 'DO Line', accessor: 'deliveryOrderLines.name', hideable: true, hideDefault: true },
  { Header: 'Units', accessor: 'unit', hideable: true, hideDefault: false },
  { Header: 'Cargo (Current)', accessor: 'currentCargo.code', hideable: true, hideDefault: false },
  {
    Header: 'Locked',
    accessor: 'locked',
    Cell: ({ value }) => <Status value={value ? 'Locked' : 'Available'} tooltip={false} />,
  },
  { Header: 'Budget', accessor: 'budgetLine.name', hideable: true, hideDefault: true },
  { Header: 'PO Line', accessor: 'purchasesLines._id', hideable: true, hideDefault: true },
  { Header: 'PO Type', accessor: 'purchasesLines.type', hideable: true, hideDefault: true },
  { Header: 'From Address', accessor: 'from.address.label', hideable: true, hideDefault: false },
  { Header: 'To Address', accessor: 'to.address.label', hideable: true, hideDefault: false },
  { Header: 'Status', accessor: 'status', Cell: StatusCell },
]

function PackageList(props) {
  const {
    list,
    fetch,
    fetching,
    selectAll,
    isSelected,
    selectionData,
    toggleSelection,
    selectionRaw,
    toggleAll,
    tableRef,
    selection,
    onShow,
  } = props

  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }

  //console.log(selectionRaw)
  return (
    <>
      {selectionData.some((i) => i.locked || i.status !== 'Confirmed') && (
        <Alert message="You can't create a Cargo with a Locked or Unconfirmed Package" type="error" showIcon />
      )}
      <CheckboxTable
        {...checkboxProps}
        withRef={tableRef}
        data={selection}
        defaultPageSize={20}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
        columns={columns}
        CreateButton={() => (
          <Button
            type={'primary'}
            size="small"
            icon={'plus'}
            disabled={selectionData.length === 0 || selectionData.some((i) => i.locked || i.status !== 'Confirmed')}
            onClick={onShow}>
            Create Cargo
          </Button>
        )}
        defaultSorted={[
          {
            id: '_key',
            desc: true,
          },
        ]}
      />
    </>
  )
}

PackageList.propTypes = {
  list: PropTypes.any,
  fetch: PropTypes.any,
  fetching: PropTypes.any,
  company: PropTypes.any,
  onChangeCompany: PropTypes.any,
  hideCompany: PropTypes.bool,
}
PackageList.defaultProps = {}

export default withRouter(PackageList)
